import { render, staticRenderFns } from "./PWPrices.vue?vue&type=template&id=a075c602&"
import script from "./PWPrices.vue?vue&type=script&lang=js&"
export * from "./PWPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports